<template>
	<div>
		<el-button size="small" class="margin-bottom-10" type="primary" @click="toUserAuth()" round><i class="fa fa-plus"></i>
			用户授权
		</el-button>
		<el-table
			class="list-table"
			ref="multipleTable"
			:data="authUserList"
			border
			tooltip-effect="dark"
			:header-cell-style="{ background: '#eef1f6', color: '#606266' }"
		>
			<template slot="empty">
				<div class="no-data">暂无数据！</div>
			</template>
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="userId" label="编号" width="150"></el-table-column>
			<el-table-column prop="loginName" label="名称" width="220"></el-table-column>
			<el-table-column prop="trueName" label="真实名称" width="220"></el-table-column>
			<el-table-column prop="roles" label="角色" min-width="240">
				<template slot-scope="scope">
          <el-tag class="margin-right-5" size="small" effect="plain" v-for="(role, index) in scope.row.roles" :key="index">{{ role.name }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="130">
				<template slot-scope="scope">
					<el-button @click="toUserAuth(scope.row)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
					<el-button @click="deleteUserAuth(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页-->
		<page-bar v-model="page" @change="fetchData"></page-bar>

    <el-dialog :title="curAuth ? '编辑用户授权' : '添加用户授权'" :visible.sync="dialogVisible" width="780px" class="form-dialog">
      <el-form ref="userAuthForm" label-width="60px" class="demo-userAuthForm">
        <el-form-item label="姓名" prop="name" placeholder="输入用户姓名,例：xxx">
          <template>
            <el-select v-model="userIds" multiple filterable placeholder="请输入姓氏进行模糊搜索" style="width: 40%">
              <el-option v-for="user in userList" :key="user.id" :label="user.trueName" :value="user.id"> </el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <template>
            <el-transfer v-model="roleIds" :props="props" :data="roleList" :titles="['角色名称', '配置角色']"></el-transfer>
          </template>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="doClose()"><i class="fa fa-close"></i> 关闭</el-button>
        <el-button type="primary" @click="saveUserAuth()"><i class="fa fa-save"></i> 保存 </el-button>
      </div>
    </el-dialog>
	</div>
</template>

<script>
import { batchSaveUserAuth, fetchUserAuth, remove } from '@/api/system/auth'
import PageBar from '@components/PageBar'
import { handleConfirm } from '@utils/confirm'
import { findAll as userList } from '@api/system/user'
import { fetchAll } from '@api/system/role'

export default {
	created() {
		this.fetchData()
	},
	components: { PageBar },
	methods: {
		fetchData() {
			fetchUserAuth({
				pageNo: this.page.pageNo,
				pageSize: this.page.pageSize,
				query: this.page.param
			}).then(resp => {
				this.authUserList = resp.data.result
			})
		},
		deleteUserAuth(val) {
      handleConfirm('你确定要回收该用户的所有授权吗, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
		},
		toUserAuth(row) {
      this.fetchUser()
      this.roleTransfer()
      this.curAuth = row
      this.dialogVisible = true

      if(!row){
        this.userIds = []
        this.roleIds = []
      }else{
        this.userIds = [row.userId]
        this.roleIds = row.roles.map(r=> r.id)
      }
		},
    fetchUser() {
      userList().then(resp => {
        this.userList = resp.data.result
      })
    },
    roleTransfer() {
      fetchAll().then(resp => {
        this.roleList = resp.data.result
      })
    },
    doClose(){
		  this.dialogVisible = false
    },
    saveUserAuth() {
      batchSaveUserAuth(this.userIds, this.roleIds).then(resp => {
        if (resp.status === 200) {
          this.$message.success(resp.data.message)
          this.fetchData()
          this.dialogVisible = false
        }
      })
    }
	},
	data() {
		return {
			page: {
				pageSize: 20,
				pageNo: 1
			},
      curAuth: null,
      dialogVisible:false,
      roleIds: [],
      userIds: [],
      roleList: [],
      userList: [],
      props: {
        key: 'id',
        label: 'name'
      },
			authUserList: []
		}
	}
}
</script>

